export const responseIndicators = {
  ANXIETY: 'Anxiety',
  DEPRESSION: 'Depression',
};
